import type { ReactNode, PropsWithChildren } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_DISABLED } from './config';
import { dummyClient } from './dummyClient';

type Props = PropsWithChildren<unknown>;

const AuthProvider = ({ children }: Props): ReactNode => {
  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      client={AUTH0_DISABLED ? dummyClient : undefined}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export { AuthProvider };
